import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./landing/landing').then((m) => m.Landing),
  },
  {
    path: 'explore',
    loadComponent: () => import('./explore/explore').then((m) => m.Explore),
  },
  {
    path: 'our-story',
    loadComponent: () => import('./our-story/our-story').then((m) => m.OurStory),
  },
  { path: 'signin', redirectTo: '', pathMatch: 'full' },
  { path: 'login', redirectTo: '', pathMatch: 'full' },

  // Main tab canonical routes from React app
  {
    path: 'app',
    loadComponent: () => import('./app-shell/app-shell').then((m) => m.AppShell),
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'addcase',
        loadComponent: () => import('./add-case/add-case').then((m) => m.AddCase),
      },
      {
        path: 'cases',
        loadComponent: () => import('./cases/cases').then((m) => m.Cases),
      },
      {
        path: 'followup',
        loadComponent: () => import('./follow-up/follow-up').then((m) => m.FollowUp),
      },
    ],
  },
  { path: 'dashboard', redirectTo: 'app/dashboard', pathMatch: 'full' },
  { path: 'addcase', redirectTo: 'app/addcase', pathMatch: 'full' },
  { path: 'add-case', redirectTo: 'app/addcase', pathMatch: 'full' },
  { path: 'cases', redirectTo: 'app/cases', pathMatch: 'full' },
  { path: 'patients', redirectTo: 'app/cases', pathMatch: 'full' },
  { path: 'followup', redirectTo: 'app/followup', pathMatch: 'full' },
  { path: 'follow-up', redirectTo: 'app/followup', pathMatch: 'full' },
  {
    path: 'import',
    loadComponent: () => import('./import/import').then((m) => m.Import),
  },
  {
    path: 'export',
    loadComponent: () => import('./export/export').then((m) => m.Export),
  },

  {
    path: '**',
    loadComponent: () => import('./not-found/not-found').then((m) => m.NotFound),
  },
];
